export type ChatAccessMode = 'ask' | 'full_access';

export const DEFAULT_CHAT_ACCESS_MODE: ChatAccessMode = 'ask';
